<template>
  <app-card
    class="p-6 flex flex-col"
    :status="attentionRequired ? 'incomplete' : 'complete'"
  >
    <div>
      <app-badge
        v-if="contract.signed_at && contract.change_acceptance_required == 0"
        type="positive"
        icon="check"
      >
        Signed
      </app-badge>
      <app-badge
        v-if="contract.signed_at && contract.change_acceptance_required == 1"
        type="neutral"
        icon="important"
      >
        Change Acceptance Required
      </app-badge>
      <app-badge
        v-if="!contract.signed_at"
        type="neutral"
        icon="important"
      >
        Unsigned
      </app-badge>
      <h2 class="text-lg">
        {{ partner.company.name }}
      </h2>
      <p>{{ contract.title }}</p>
    </div>
    <div class="text-grey-700 mt-auto text-sm mt-2 mb-6">
      <template v-if="contract.signed_at">
        <p><b>Signatory:</b> {{ signed_by }}</p>
        <p><b>Date:</b> {{ signed_at }}</p>
      </template>
      <template v-if="!contract.signed_at && !canSign && isCompanyUser">
        <p class="text-neutral-800 italic mt-2">
          The contract needs to be signed by the primary user for your company.
        </p>
      </template>
      <template v-if="canSign && contract.change_acceptance_required == 1">
        <div class="text-neutral-800 mt-2 p-1 border border-neutral-500 bg-neutral-100">
          <p class="font-bold uppercase text-xs">Details</p>
          {{ contract.change_details }}
        </div>
      </template>
    </div>
    <div class="border-t pt-4 flex items-center">
      <p>
        <small>Version: {{ contract.revision }}</small>
      </p>
      <template v-if="contract.signed_at">
        <icon-link
          v-if="contract.file && contract.change_acceptance_required == 0"
          :href="
            route('applications.files.download-project-file-from-path', {
              application: uuid,
              file: contract.file
            })
          "
          class="ml-auto"
          icon="cheveron-down-circle"
          icon-placement="right"
          target="_blank"
        >
          Download
        </icon-link>
        <icon-link 
          v-if="canSign && contract.change_acceptance_required == 1"
          :href="
            route('projects.contracts.review', {
              project: uuid,
              contract: contract.id
            })
          "
          class="ml-auto"
          icon="cheveron-down-circle"
          icon-placement="right"
        >
          Review Change
        </icon-link>
      </template>
      <template v-else>
        <icon-link
          v-if="canSign"
          :href="
            route('projects.contracts.view', {
              project: uuid,
              contract: contract.id
            })
          "
          class="ml-auto"
          icon="cheveron-down-circle"
          icon-placement="right"
        >
          Sign
        </icon-link>
      </template>
    </div>
  </app-card>
</template>

<script>
import { format, parseISO } from "date-fns";
export default {
  name: "UserContractCard",
  props: {
    partner: {
      type: Object,
      required: true
    }
  },
  computed: {
    uuid() {
      return window._project;
    },
    authUser() {
      return window._user;
    },
    canSign() {
      if (this.authUser.is_monitor) return false;
      return this.isCompanyUser && this.authUser.isEditor;
    },
    isCompanyUser() {
      return this.authUser.company_id === this.partner_company.id;
    },
    attentionRequired() {
      return ! this.contract.signed_at || this.contract.change_acceptance_required == 1
    },
    signed_by() {
      const user = this.partner.users.find(
        user => user.user_id === this.contract.signed_by
      );
      if (!user) return false;
      return user.user.name;
    },
    signed_at() {
      if (!this.contract.signed_at) return false;
      return format(parseISO(this.contract.signed_at), "do MMMM yyyy HH:mm");
    },
    partner_company() {
      return this.partner.company;
    },
    contract() {
      return this.partner.latest_contract;
    }
  }
};
</script>
